import React, { Component } from 'react';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';

var location = {lat:null, lng: null}
class MapContainer2 extends Component {  
  
    
    
  render() {
    // {console.log("Location")
    // console.log(this.props)}
    return (

      
      <Map
      google={this.props.google}
      style={{height:"250px",width:"450px", position:"absolute"}}
      center={{
        lat: this.props.lat, 
            lng: this.props.lng
      }}
      zoom={14}
      onClick={this.onMapClicked}
      
    > 

    <Marker position={{lat: this.props.lat, 
            lng: this.props.lng}} title={this.props.name}/>
    
        <InfoWindow onClose={this.onInfoWindowClose}>
            <div>
              <h1>{"175 Corning Lane, Gaithersburg,MD 20878"}</h1>
            </div>
        </InfoWindow>
      </Map>
      
    );
  }
};
 
export default GoogleApiWrapper({
  apiKey: 'AIzaSyBxLd_UmZ_U0NLhQvqTLd-Ek_k3SbOkykI'
})(MapContainer2)
